const mutations = {
  /**
   * Set the access token property on state
   * with token param.
   *
   * @param state
   * @param token
   */
  setAccessToken(state, token) {
    state.accessToken = token;
  },

  /**
   * Remove the access token property
   * on state, defining the accessToken property
   * with empty string value.
   *
   * @param state
   */
  removeAccessToken(state) {
    state.accessToken = '';
  },

  /**
   * Set the access token as expired, defining
   * the accessTokenExpired with true value.
   *
   * @param state
   */
  setAccessTokenAsExpired(state) {
    state.accessTokenExpired = true;
  },

  /**
   * Set the access token as not expired, defining
   * the accessTokenExpired with false value.
   *
   * @param state
   */
  setAccessTokenAsNotExpired(state) {
    state.accessTokenExpired = false;
  },

  /**
   * Set the authenticated user, defining
   * the user property in state with user parameter.
   *
   * @param state
   * @param user
   */
  setUser(state, user) {
    if (user && user.plan === null) {
      user.plan = {
        id: null,
        prepaid: null,
        name: null,
        price: null,
        price_per_consultation: null,
      };
    }
    if (user && user.organizationPlan === null) {
      user.organizationPlan = {
        plan_id: null,
        auto_recharge_value: null,
        cancellation_date: null,
        next_plan_id: null,
        change_date: null,
      };
    }

    state.user = user;
  },

  /**
   * Set the tokens, defining
   * the tokens property in state with tokens parameter.
   *
   * @param state
   * @param tokens
   */
  setTokens(state, tokens) {
    state.tokens = tokens;
  },

  /**
   * Set the invite data
   *
   * @param state
   * @param invite
   */
  setInvite(state, invite) {
    state.invite = invite;
  },

  /**
   * Set the users, defining
   * the tokens property in state with tokens parameter.
   *
   * @param state
   * @param users
   */
  setUsers(state, users) {
    state.users = users;
  },

  setInvites(state, invites) {
    state.invites = invites;
  },
};

export default mutations;
